import { compact } from 'lodash';

import { Address } from '@dreryk/address-common-api';

import { getCurrentLocale } from '@dreryk/react-common';

type AddressProps = {
   readonly address: Address;
};

function filter(item: string | undefined): string {
   return item ?? '';
}

function formatStreet(address: Address): string {
   const flat = address.findFlat();
   const building = address.findBuilding();
   const number = flat ? ` ${filter(building?.asString())}/${flat.asString()}` : building?.asString();
   const numbStr = number ? ` ${number}` : '';
   const street = address.findStreet();
   return street ? `ul. ${street.asString()}${numbStr}` : '';
}

function formatCity(address: Address): string {
   const postcode = address.findPostcode();
   const formattedPostcode = postcode ? `${postcode.asString()} ` : '';
   return `${formattedPostcode}${filter(address.findTown()?.getName())}`;
}

function formatCountry(address: Address): string | undefined {
   const locale = getCurrentLocale();
   const country = address.getCountry();
   return country.getName(locale);
}

function formatAddress(address: Address): string {
   return compact([formatStreet(address), formatCity(address), formatCountry(address)]).join(', ');
}

export const AddressCell = (props: AddressProps): JSX.Element => {
   return <>{formatAddress(props.address)}</>;
};
